import React from "react";
import { Link } from "react-router-dom";
import "./CareersPreview.css";

export const CareersPreview = () => {
  return (
    <section className="careers-preview-hero">
      <div className="container">

        <span className="section-label">Join Our Team</span>

        <h1 className="careers-preview-title">
          Build Your Career at <span className="gradient-text">AJERA IT</span>
        </h1>

        <p className="careers-preview-sub">
          Whether you're looking for a full-time role, a hands-on internship, or want
          to upskill with industry-ready courses — we have the right path for you.
        </p>

        {/* CTA */}
        <div className="careers-preview-cta">
          <Link to="/careers" className="btn-primary">
            View All →
          </Link>
        </div>

      </div>
    </section>
  );
};